import { forceDeleteCsrfCookie, deleteCsrfCookie } from '../../../application/csrfProtection/clearCookies';
import { REDIRECT_PARAM_NAME } from '../../route/authRedirect/REDIRECT_PARAM_NAME';

const unauthorizedCodes = new Set(['401', '440']);
let isUnauthorizedHandlingStarted = false;

export const isUnauthorizedRedirectInProgress = () => isUnauthorizedHandlingStarted;

export const handleUnauthorizedError = (errorResponse: any): void => {
  if (typeof window === 'undefined' || isUnauthorizedHandlingStarted) {
    return;
  }

  const responseStatus = String(errorResponse?.status ?? errorResponse?.response?.status ?? '');
  const jsonStatus = String(errorResponse?.json?.status ?? '');
  const webCode = String(errorResponse?.json?.webCode ?? '');
  const isUnauthorized =
    unauthorizedCodes.has(responseStatus) || unauthorizedCodes.has(jsonStatus) || unauthorizedCodes.has(webCode);

  if (!isUnauthorized) {
    return;
  }

  isUnauthorizedHandlingStarted = true;

  const cookieDeleted = deleteCsrfCookie();
  if (!cookieDeleted) {
    forceDeleteCsrfCookie();
  }

  const isOnLoginPage = window.location.pathname.startsWith('/login');
  if (isOnLoginPage) {
    setTimeout(() => {
      window.location.reload();
    }, 100);
    return;
  }

  const redirect = encodeURIComponent(window.location.href);
  window.location.assign(`/login?${REDIRECT_PARAM_NAME}=${redirect}`);
};
